module.exports = __webpack_public_path__ + "images/feature/20190401-6993f2af2f9f395edd0e5c23d218e375.png";